import React from 'react'
import useLoadScoredScene from "../../../videosScored/utils/useLoadScoredScene";
import ScoredSceneCardDetailed from "../../../videosScored/card/scoredSceneDetailed/ScoredSceneCardDetailed";
import {CircularProgress} from "@mui/material";

// clickable can only be set to true, if it is used within the react-router-dom
const StatisticsScoredSceneSummary = ({scoredSceneKey}) => {
    const {selectedScoredScene, loading} = useLoadScoredScene(null, scoredSceneKey)

    if (loading) {
        return <CircularProgress/>
    }

    return <ScoredSceneCardDetailed scoredScene={selectedScoredScene}/>
}
export default StatisticsScoredSceneSummary
